var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _moment = _interopRequireDefault(require("moment"));

var _Basic = require("../../../elements/Basic");

var _i18n = _interopRequireDefault(require("../../../i18n"));

var _Touchable = _interopRequireDefault(require("../Basic/Touchable"));

var _Logos = require("../Basic/Logos");

var _PlayerName = _interopRequireDefault(require("../Basic/PlayerName"));

var _PropsHelper = require("../../../utilities/PropsHelper");

var _jsxFileName = "/builds/sport1/libraries/universal-components/lib/components/Universal/Squad/index.js";

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = (0, _getPrototypeOf2.default)(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = (0, _getPrototypeOf2.default)(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return (0, _possibleConstructorReturn2.default)(this, result);
  };
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

var Squad = function (_React$Component) {
  (0, _inherits2.default)(Squad, _React$Component);

  var _super = _createSuper(Squad);

  function Squad() {
    (0, _classCallCheck2.default)(this, Squad);
    return _super.apply(this, arguments);
  }

  (0, _createClass2.default)(Squad, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          member = _this$props.member,
          onPress = _this$props.onPress,
          boxStyle = _this$props.boxStyle,
          NavWrapper = _this$props.NavWrapper,
          href = _this$props.href,
          rest = (0, _objectWithoutProperties2.default)(_this$props, ["member", "onPress", "boxStyle", "NavWrapper", "href"]);
      if (!member) return null;
      var nationality = member.nationality;
      var age = (0, _moment.default)().diff(member.birthday, 'years');
      var footer = [nationality ? _react.default.createElement(_Logos.Logo, {
        key: "nationality_logo_" + nationality.imageUrl,
        width: 14,
        height: 9,
        src: nationality.imageUrl,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 37,
          columnNumber: 17
        }
      }) : null, _react.default.createElement(_Basic.Text, {
        key: "nationality_name",
        px: 2,
        grow: true,
        numberOfLines: 1,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 44,
          columnNumber: 13
        }
      }, nationality && nationality.name)];
      return _react.default.createElement(_Touchable.default, (0, _extends2.default)({
        href: href,
        NavWrapper: NavWrapper,
        onPress: (0, _PropsHelper.getFunctionAsCallbackOrUndefined)(onPress, member)
      }, rest, {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 50,
          columnNumber: 13
        }
      }), _react.default.createElement(_Basic.Row, (0, _extends2.default)({
        isFlex: true
      }, boxStyle, {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 56,
          columnNumber: 17
        }
      }), _react.default.createElement(_Basic.Column, {
        isFlex: true,
        center: true,
        mr: 3,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 57,
          columnNumber: 21
        }
      }, _react.default.createElement(_Logos.CircleLogo, {
        size: 40,
        src: member.imageUrl,
        imageType: "player",
        __source: {
          fileName: _jsxFileName,
          lineNumber: 58,
          columnNumber: 25
        }
      })), _react.default.createElement(_Basic.Column, {
        flexing: true,
        minWidth: 0,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 60,
          columnNumber: 21
        }
      }, _react.default.createElement(_Basic.Row, {
        flexing: true,
        centerHorizontal: true,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 61,
          columnNumber: 25
        }
      }, _react.default.createElement(_PlayerName.default, {
        isTitle: false,
        grow: true,
        bold: true,
        player: member,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 62,
          columnNumber: 29
        }
      }), _react.default.createElement(_Basic.Text, {
        bold: true,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 63,
          columnNumber: 29
        }
      }, member.jerseyNumber)), _react.default.createElement(_Basic.Row, {
        flexing: true,
        centerHorizontal: true,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 65,
          columnNumber: 25
        }
      }, footer, _react.default.createElement(_Basic.Text, {
        key: "player_age",
        __source: {
          fileName: _jsxFileName,
          lineNumber: 67,
          columnNumber: 29
        }
      }, age, " ", (0, _i18n.default)('years'))))));
    }
  }]);
  return Squad;
}(_react.default.Component);

Squad.propTypes = {
  member: _propTypes.default.object.isRequired,
  boxStyle: _propTypes.default.object,
  onPress: _propTypes.default.func,
  NavWrapper: _propTypes.default.func
};
Squad.defaultProps = {
  boxStyle: {
    p: 2,
    mb: 2,
    borderX: 1,
    borderY: 1,
    borderColor: 'border.main'
  }
};
var _default = Squad;
exports.default = _default;